<template>
  <div>
    <Head title="Accessories" />
    <div class="flex items-center mb-8">
      <h1 class="text-3xl font-bold">Accessories</h1>
      <span class="text-xs mx-2 rounded-full p-2 bg-gray-200"> {{ accessories.total }}</span>
    </div>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Deleted:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">Exclude Deleted</option>
          <option value="with">Include Deleted</option>
          <option value="only">Only Deleted</option>
        </select>
      </search-filter>
      <a href="/accessories/export" target="_blank" class="border border-gray-600 text-gray-600 flex items-center py-3 px-4 hover:bg-gray-600 hover:text-white" download>Export</a>
    </div>
    <div class="bg-white  shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Part number</th>
            <th class="pb-4 pt-6 px-6">System</th>
            <th class="pb-4 pt-6 px-6">Width</th>
            <th class="pb-4 pt-6 px-6">Length</th>
            <th class="pb-4 pt-6 px-6">Oulet Type</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="accessory in accessories.data" :key="accessory.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <div class="px-4 py-6">{{ accessory.part_number }}</div>
            </td>
            <td class="border-t">
              <div class="px-4 py-6">{{ accessory.system }}</div>
            </td>
            <td class="border-t">
              <div class="px-4 py-6">{{ accessory.width }}</div>
            </td>
            <td class="border-t">
              <div class="px-4 py-6">{{ accessory.length }}</div>
            </td>
            <td class="border-t">
              <div class="px-4 py-6">{{ accessory.outlet_type }}</div>
            </td>
          </tr>
          <tr v-if="accessories.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No accessorys found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="accessories.links" :total="accessories.total" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters    : Object,
    accessories: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/accessories', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
